import * as actions from '../actionTypes'

const initialState = {
  metaData: {
    cookiesEnabled: false,
    isLoading: false,
  },
}

const MetaDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.COOKIES_ENABLED: {
      return {
        ...state,
        metaData: {
          ...state.metaData,
          cookiesEnabled: action.payload.description,
        },
      }
    }
    case actions.SCREEN_LOADING: {
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: action.payload.description,
        },
      }
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default: {
      return state
    }
  }
}
export default MetaDataReducer
